import FingoMuiAutocomplete, { credentialProviderAutocomplete } from '../../fingo/components/MuiAutocomplete';
import { CREDENTIAL_PROVIDER_AUTOCOMPLETE_CLASS_NAME } from '../../constants/autocomplete';

const MuiAutocomplete = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiAutocomplete.styleOverrides.root({ theme }),
      [`&.${CREDENTIAL_PROVIDER_AUTOCOMPLETE_CLASS_NAME}`]: credentialProviderAutocomplete({ theme, mainColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiAutocomplete;
